module.exports = __webpack_public_path__ + "img/2164ccc215dc1c5be2c522ec20940b3c.jpg";